export const TRANSLATION_SCOPE = 'homeModule';
export const TRANSLATION_HOME_SCOPE = [TRANSLATION_SCOPE, 'home'];
